/* eslint-disable @typescript-eslint/no-unused-vars */
import { Fragment, useEffect } from "react";
import { useWebStoreContext } from "contexts/WebStoreProvider";
import { useGetOffersQuery } from "redux/apis";
import { IShopPurchaseOfferElite } from "contexts/WebStoreProvider/types";
import { orderBy } from "lodash";
import { Skeleton, useMediaQuery } from "@mui/material";
import { SectionIconContainer } from "styles/general_styles";
import { loop } from "utils/loop";
import useNewDay from "hooks/useNewDay";
import { EliteDealsIcon } from "utils/svgIcons";
import SectionHeader from "components/Section/SectionHeader";
import { ELITE_DEALS_GOLD } from "pages/EliteDeals/helpers/colors";
import { Box } from "./Box";
import { BoxSkeleton } from "./Box/skeleton";
import { IDealsBoxesResponse } from "interfaces/elite-deals";
import { OffersContainer } from "./styles";

export const DealsBoxes = () => {
	const { authToken, store } = useWebStoreContext();
	const { newDay } = useNewDay();
	const {
		data: boxesData,
		isLoading: isBoxesLoading,
		refetch
	}: {
		data?: IDealsBoxesResponse;
		isLoading: boolean;
		refetch: () => void;
	} = useGetOffersQuery(
		{
			offerType: "elite",
			isAuthenticated: !!authToken?.value
		},
		{ pollingInterval: 600000 }
	);

	const orderedOfferes = orderBy(boxesData?.offers, ["priority"], ["asc"]);

	useEffect(() => {
		refetch();
	}, [newDay]);

	if (isBoxesLoading || !store) {
		return (
			<Fragment>
				<section id="gift-boxes">
					<Skeleton animation="wave" variant="text" width={220} height={65} />
				</section>
				<OffersContainer className="loading">
					{loop(4, (i: number) => (
						<BoxSkeleton key={`box-${i}`} />
					))}
				</OffersContainer>
			</Fragment>
		);
	}

	if (boxesData && !boxesData?.offers) {
		return null;
	}

	return (
		<Fragment>
			<section id="deals-boxes">
				<SectionHeader
					text="ELITE DEALS"
					icon={
						<SectionIconContainer>
							<EliteDealsIcon />
						</SectionIconContainer>
					}
					sx={{
						color: ELITE_DEALS_GOLD,
						"& svg": {
							fill: ELITE_DEALS_GOLD,
							width: "30px",
							height: "30px"
						}
					}}
				/>
			</section>
			<OffersContainer>
				{orderedOfferes.map((offer: IShopPurchaseOfferElite) => (
					<Box
						key={offer.id}
						offer={offer}
						refetch={refetch}
						className={orderedOfferes?.length === 3 ? "three-cards" : ""}
					/>
				))}
			</OffersContainer>
		</Fragment>
	);
};
